/**
 * Calculate the demo stop limit based on demo configuration
 * @param isDemo - Whether the tour is in demo mode
 * @param demoStop - The demo_stop value from tour state
 * @returns The index limit for unlocked stops, or undefined if not in demo mode
 */
export function calculateDemoStopLimit(isDemo: boolean, demoStop: number | undefined): number | undefined {
  if (!isDemo) return undefined;

  if (demoStop === undefined) return 2 - 1;  // Default: show 1 stop (index 0-1)
  if (demoStop === 0) return 0 - 1;           // Show 0 stops (all locked)
  if (typeof demoStop === 'number' && demoStop >= 1) return demoStop - 1;

  return undefined;
}
